import type { NavigationMenuItem } from "@nuxt/ui";

export const MENU_LISTS: NavigationMenuItem[][] = [
  [
    {
      label: "แดชบอร์ด",
      type: "label",
    },
    {
      label: "ภาพรวมระบบ",
      icon: "i-lucide-layout-dashboard",
      to: {
        name: "admin-dashboard",
      },
    },
  ],
  [
    {
      label: "รายงาน",
      type: "label",
    },
    {
      label: "ตั้งค่าคำถามรายงาน",
      icon: "i-lucide-file-text",
      to: {
        name: "admin-report-question",
      },
    },
    {
      label: "รายงานประจำวัน",
      icon: "i-lucide-file-chart-line",
      to: {
        name: "admin-report-daily",
      },
    },
  ],
  [
    {
      label: "เตรียมความรู้พนักงาน",
      type: "label",
    },
    {
      label: "ตั้งค่าแบบทดสอบบันทึกเสียง",
      icon: "i-lucide-clipboard-type",
      to: {
        name: "admin-audio-record-config",
      },
    },
    {
      label: "ผลลัพธ์แบบทดสอบบันทึกเสียง",
      icon: "i-lucide-speech",
      to: {
        name: "admin-audio-record-log",
      },
    },
  ],
  [
    {
      label: "องค์กร",
      type: "label",
    },
    {
      label: "บริษัทและโครงสร้างองค์กร",
      icon: "i-lucide-building",
      to: {
        name: "admin-organization-company",
      },
      "data-tutorial": "page-company-organization",
    },
    {
      label: "ผู้ใช้งาน",
      icon: "i-lucide-users",
      to: {
        name: "admin-organization-user",
      },
      "data-tutorial": "click-page-user",
    },
  ],
  // [
  //   {
  //     label: "ข้อมูลดิบจาก Line",
  //     type: "label",
  //   },
  //   {
  //     label: "ดูข้อมูลตามผู้ใช้งาน LINE",
  //     icon: "i-lucide-house",
  //   },
  //   {
  //     label: "ดูข้อมูลตามประเภทไฟล์",
  //     icon: "i-lucide-inbox",
  //   },
  // ],
  [
    // {
    //   label: "ตั้งค่าระบบ",
    //   type: "label",
    // },
    // {
    //   label: "ตั้งค่าระบบ",
    //   icon: "i-lucide-house",
    // },
    // {
    //   label: "ข้อความ",
    //   icon: "i-lucide-inbox",
    // },
    // {
    //   label: "ตั้งค่า AI Prompts",
    //   icon: "i-lucide-bot",
    //   to: {
    //     name: "admin-prompt",
    //   },
    // },

    // {
    //   label: "ตัวแปรระบบ",
    //   icon: "i-lucide-inbox",
    // },
    {
      label: "แนะนำการใช้งาน",
      type: "label",
    },
    {
      label: "แนะนำการใช้งาน",
      icon: "i-lucide-monitor-play",
      trailingIcon: "i-lucide-square-arrow-out-up-right",
      to: "https://drive.google.com/drive/folders/1T-C0oBNPCWfpD04fK_wTxlEZGojYxu4G?usp=drive_link",
      target: "_blank",
    },
  ],
];
